import { ChillerBonusAssignedUsersModel } from './../../../shared/models/visibility';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbDate, NgbDatepicker, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard';
import { of } from 'rxjs';
import { ExcelModel } from 'src/app/hubadmin/shared/models/geography';
import { StateModel } from 'src/app/hubadmin/shared/models/state';
import { chillerBonusPointSchemeModel, ChillerScheme, ChillerSelectionModel, ChillerUserWiseBounsPointModel } from 'src/app/hubadmin/shared/models/visibility';
import { ChannelProvider } from 'src/app/hubadmin/shared/providers/channel.provider';
import { FrequencyProvider } from 'src/app/hubadmin/shared/providers/frequency.provider';
import { GeographyProvider } from 'src/app/hubadmin/shared/providers/geography.provider';
import { AdminDataProvider } from 'src/app/hubadmin/shared/providers/master-provider/admin-data.provider';
import { RegionProvider } from 'src/app/hubadmin/shared/providers/region.provider';
import { RolesProvider } from 'src/app/hubadmin/shared/providers/roles.provider';
import { UnitsProvider } from 'src/app/hubadmin/shared/providers/units.provider';
import { DateFormateService } from 'src/app/services/date-formate.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-add-chiller-scheme',
  templateUrl: './add-chiller-scheme.component.html',
  styleUrls: ['./add-chiller-scheme.component.scss']
})
export class AddChillerSchemeComponent implements OnInit {
  fromDate: NgbDate;
  toDate: NgbDate;
  @ViewChild(NgbDatepicker, { static: false }) datePicker;
  frequencyList: any = [];
  id;
  formData: FormGroup;
  submitted: boolean = false;
  regions: any = [];
  channels: any = [];
  states: StateModel[];
  geography: any = [];
  posmElements: any = [];
  disabled: boolean = false;
  submittedLevels: any = { isSubmitted: false, state: "engagement" };
  searchText: any;
  tempOptionModel: any;
  private _parameters: any;
  AssignedUsers: any[];
  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden,
  };
  isFirstOpen = true;
  isImage: boolean = true;
  outletmasterSelected: boolean = false;
  wizardButtonText = "Submit";
  sampleTemplate: any;
  headerText: string = "Add";
  config: NgWizardConfig = {
    // selected: 0,
    anchorSettings: { anchorClickable: true },
    theme: THEME.default,
  };
  excel: ExcelModel = new ExcelModel();
  items: FormArray;
  @Input() model: chillerBonusPointSchemeModel = new chillerBonusPointSchemeModel;
  chillerSelection: ChillerSelectionModel[];
  points_based: boolean = false;
  excelFileName: any;
  excel_data: any;
  bounsSelection: ChillerSelectionModel[];
  uploadedUsers: ChillerUserWiseBounsPointModel[];
  uploaded: boolean = false;
  responseObj: any;
  min: number;
  max: number;
  mode: number = 1; //1 = add, 2=edit
  options: any[] = [];
  minDate: { year: number; month: number; day: number; };
  constructor(
    public modalService: NgbModal,
    public fb: FormBuilder,
    public ngWizardService: NgWizardService,
    public adminDataProvider: AdminDataProvider,
    public apiService: ApiService,
    public apiConfig: ApiConfiguration,
    public router: Router,
    private formBuilder: FormBuilder,
    public frequencyProviders: FrequencyProvider,
    private route: ActivatedRoute,
    private formateDate: DateFormateService,
    public regionProviders: RegionProvider,
    public unitsProviders: UnitsProvider,
    public channelProviders: ChannelProvider,
    public geoProviders: GeographyProvider,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService,
    private toast: ToastClientService,
    private userRoles: RolesProvider,
    public ngxService: NgxUiLoaderService,
    public alertService: AlertService,
    private uploadFile: UploadZipService,
    public activatedRoute: ActivatedRoute,
  ) {

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };

    this.config = {
      selected: 0,
      anchorSettings: { anchorClickable: true },
      theme: THEME.default,
      toolbarSettings: {
        toolbarExtraButtons: [],
      },
    };

    this.formData = this.formBuilder.group({
      scheme_name: ["", Validators.required, Validators.pattern('[a-zA-Z0-9-_ ]*')],
      start_date: ["", Validators.required],
      end_date: ["", Validators.required],
      userExcel: ["",],
      chiller_month: ["", Validators.required],
      chiller_year: ["", Validators.required]
    });

    this.uploadFile.currentMessage.subscribe(message => {
      if (message.status == 'success') {
        console.log(message)
        this.responseObj = message.response;
        this.id = this.responseObj.id;
        this.getAllBonusSchemeUsers(this.id);
        this.configuratePoints();
        this.showNextStep();
        this.points_based = false;
      }
    });
  }

  loaderStart() {
    try {
      this.ngxService.start();
    } catch (error) {
      console.log(error);
    }
  }
  loaderDismiss() {
    try {
      // this.loadingCntr.dismiss();
      this.ngxService.stop();
    } catch (error) { }
  }

  getYears() {
    (this.min = 2019), (this.max = new Date().getFullYear());
    let options = "<option>Select Year</option>";
    for (var i = this.min; i <= this.max; i++) {
      options += '<option value="' + i + '">' + i + "</option>";
      this.options.push(i);
    }
    this.options.reverse();
  }

  ngAfterViewInit() {
    (document.querySelector('.tabSaveBtn') as HTMLElement).style.display = 'none';
  }
  downloadExcel() {
    this.exportExcelService.exportUserAssignment();
  }

  getChillerScheme(id) {
    this.apiService
      .getHeaders(
        this.apiConfig.getChillerSchemes + "?id=" + id
      )
      .subscribe(
        (res: any) => {
          this.model = res.body.data as chillerBonusPointSchemeModel;
          this.model.show = false;
          this.getFormModel();
          this.model.statusString = (this.model.status == 1) ? "Active" : "Inactive";
          if (new Date(this.model.start_date) >= new Date()) {
            this.model.show = true;
          }
          this.addDates();
        },
        (err) => {
          console.log(err);
        }
      );
  }

  ngOnInit() {
    this.loaderStart();
    this.getChillerSelection();
    this.getYears();
    this.headerText = "Add";
    this._parameters = this.activatedRoute.params.subscribe((params) => {
      if (typeof params["id"] !== "undefined") {
        if (params["id"] !== "") {
          this.headerText = "Edit";
          this.id = Number.parseInt(params["id"]);
          this.getChillerScheme(this.id);
          this.getAllBonusSchemeUsers(this.id);
          this.mode =2;
        }
      }
      else {
        this.headerText = "Add";
      }
    });
    this.loaderDismiss();
    this.clearSuccess();
  }

  skip(){
    this.showNextStep();
  }

  get f() {
    return this.formData.controls;
  }

  get t() {
    return this.f.items as FormArray;
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      chiller_bonus_selection_id: ["", [Validators.required]],
      points: ["", [Validators.required, Validators.pattern(/^[1-9]\d*$/)]],
    });
  }

  addItem(): void {
    this.items = this.formData.get("items") as FormArray;
    this.items.push(this.createItem());
  }

  removeItem(i): void {
    this.t.removeAt(i);
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

  getChillerSelection() {
    this.apiService.getHeaders(this.apiConfig.getChillerSelection).subscribe(
      (res: any) => {
        this.chillerSelection = res.body.data as ChillerSelectionModel[];
        this.bounsSelection = this.chillerSelection;
      },
      (err) => {
        console.log(err);
        this.toast.Error(err);
      }
    );
  }

  getAllBonusSchemeUsers(id) {
    this.apiService.getHeaders(this.apiConfig.getUploadSchemeVisiblityUsers + "?id=" + id).subscribe(
      (res: any) => {
        this.uploadedUsers = res.body.data.data as ChillerUserWiseBounsPointModel[];
        console.log("www"+this.uploadedUsers);
        if (this.uploadedUsers.length > 0) {
          this.uploadedUsers.forEach(
            i => {
              i.isEdit = false;
              i.show = false;
              i.statusString = i.status == 1 ? "Active" : "Inactive";
              if (this.model.show == true) {
                i.show = true;
              }
            }
          )
        }else{
          this.toast.Error(res.body.data.message);
        }
      },
      (err) => {
        console.log(err);
        this.toast.Error(err);
      }
    );
  }

  // paginationClick(item) {
  //   this.pageNumber = item;
  //   this.getAllBonusSchemeUsers(this.id);
  // }

  isNameDup() {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map(control => control.value);
      const names = totalSelected.map(value => value.chiller_bonus_selection_id)
      const hasDuplicate = names.some(
        (name, index) => names.indexOf(name, index + 1) != -1
      );
      return hasDuplicate ? { duplicate: true } : null;
    }
    return validator;
  }


  /* wizard section start */
  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }

  showNextStep(event?: Event) {
    this.ngWizardService.next();
  }

  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }

  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }

  stepChanged(args: StepChangedArgs) {
    this.submittedLevels.state = args.step.index;
  }
  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }

  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }

  configuratePoints() {
    this.points_based = !this.points_based;
    if (this.points_based) {
      this.formData.controls['userExcel'].setValidators([Validators.required]);
      this.formData.addControl('items', new FormArray([this.createItem()], this.isNameDup()));
    }
    else {
      this.formData.removeControl('items');
    }
  }

  setFormModel() {
    this.model.chiller_month = this.formData.controls['chiller_month'].value;
    this.model.chiller_year = this.formData.controls['chiller_year'].value;
  }

  getFormModel() {
    this.formData.controls['chiller_month'].setValue(this.model.chiller_month);
    this.formData.controls['chiller_year'].setValue(this.model.chiller_year);
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    this.setFormModel();
    let startDate = this.formData.controls['start_date'].value;
    let endDate = this.formData.controls['end_date'].value;
    this.model.scheme_name = this.formData.controls['scheme_name'].value;

    if (startDate != null && endDate != null) {
      this.formData.controls['start_date'].clearValidators();
      this.formData.controls['end_date'].clearValidators();
      this.formData.controls['start_date'].updateValueAndValidity();
      this.formData.controls['end_date'].updateValueAndValidity();
    }
    else {
      this.formData.controls['start_date'].setValidators([Validators.required]);
      this.formData.controls['end_date'].setValidators([Validators.required]);
      this.formData.controls['start_date'].updateValueAndValidity();
      this.formData.controls['end_date'].updateValueAndValidity();
    }


    console.log(this.formData);
    if (this.formData.invalid) {
      return;
    }

    this.model.start_date = this.formateDate.formateDate(this.model.startDate);
    this.model.end_date = this.formateDate.formateDate(this.model.endDate);

    if (new Date(this.model.end_date) < new Date(this.model.start_date)) {
      this.toast.Error("End Date can\'t before Start date");
      return;
    }

    if (this.points_based) {
      debugger
      this.model.items = this.formData.controls['items'].value;
      this.loaderStart();
      this.uploadMultiData(this.model);
      this.loaderDismiss();
    }
    else {
      if (this.model.id) {
        this.loaderStart();
        this.update();
        this.loaderDismiss();
      }
      else {
        this.loaderStart();
        this.create();
        this.loaderDismiss();
      }
    }
    this.addDates();
  }

  addDates() {
    let dates = {
      start: this.model.start_date.split("-"),
      end: this.model.end_date.split("-"),
    };
    let startDate = {
      year: parseInt(dates.start[0]),
      month: parseInt(dates.start[1]),
      day: parseInt(dates.start[2]),
    };
    let endDate = {
      year: parseInt(dates.end[0]),
      month: parseInt(dates.end[1]),
      day: parseInt(dates.end[2]),
    };
    this.model.startDate = startDate;
    this.model.endDate = endDate;
  }

  create() {
    this.apiService.post(this.apiConfig.CreateSchemenUploadVisiblityUsers, this.model).subscribe(
      (res: any) => {
        this.id = res.body.data.id;
        this.toast.Success(res.body.data.schemedetails.message);
        this.getChillerScheme(this.id);
        this.showNextStep();
      },
      (err) => {
        console.log("err", err);
        this.toast.Error(err);
      }
    );
  }

  update() {
    this.apiService.post(this.apiConfig.updateSchemenUploadVisiblityUsers, this.model).subscribe(
      (res: any) => {
        this.id = res.body.data.id;
        this.toast.Success(res.body.data.schemedetails.message);
        this.getChillerScheme(this.id);
        this.showNextStep();
      },
      (err) => {
        console.log("err", err);
        this.toast.Error(err);
      }
    );
  }

  uploadMultiData(data) {
    let url;
    if (data.id != null) {
      url = this.apiConfig.updateSchemenUploadVisiblityUsers
    }
    else {
      url = this.apiConfig.CreateSchemenUploadVisiblityUsers;
    }
    this.enableUploadDiv(data, url);
  }

  enableUploadDiv(data, url) {
    this.uploadFile.changeMessage({
      status: "upload",
      data: data,
      url: url,
      module: "Bouns Points Scheme",
      zip: "no",
      excelname: this.excelFileName,
    });
  }

  uploadXlsx(eve, status) {
    if (eve.target.files) {
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then((res: any) => {
      this.excel_data = res.data;
      console.log(this.excel_data);
      this.model.excel = this.excel_data;
      this.xlsxView(res)
    });
  }

  xlsxView(data) {
    // data.apiHeaders = this.brandsListHeaders;
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        if (result.length > 0) {
          this.model.excel = result;
        }
        else {
          this.formData.controls['userExcel'].reset();
        }
      },
      (reason) => { }
    );
  }


  onReset() {
    // reset whole form back to initial state
    this.submitted = false;
    this.formData.reset();
    this.t.clear();
    this.t.push(this.createItem());
    this.points_based = false;
  }

  onClear() {
    // clear errors and reset ticket fields
    this.submitted = false;
    this.formData.reset();
    this.t.reset();
    this.points_based = false;
  }

  editRow(index, item) {
    item.isEdit = true;
  }

  updateData(index, item, type) {
    item.isEdit = false;
    if (type == "delete") {
      item.status = 0;
    }
    this.updateUserDataById(item, type, index);
  }

  updateUserDataById(item: ChillerUserWiseBounsPointModel, type, index) {
    this.apiService
      .put(this.apiConfig.UpdateUploadSchemeVisiblityUsers + "?id=" + item.id, item)
      .subscribe((res: any) => {
        if (res.status == 201 || res.status == 200) {
          if (type == "edit") {
            this.toast.Success(res.data.message);
          } else if (type == "delete") {
            item.status = 0;
            this.uploadedUsers.splice(index, 1);
            this.toast.Success("Deleted successfully");
          }
        }
      });
  }

  changeUserStatus(item: ChillerBonusAssignedUsersModel) {
    item.status = item.status == false ? 0 : 1;
    this.apiService
      .put(this.apiConfig.UpdateUploadSchemeVisiblityUsers + "?id=" + item.id, item)
      .subscribe((res: any) => {
        this.toast.Success(res.data.message);
      });
  }

  allow_Only_numbers(event) {
    var k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  omit_special_char(event) {
    var k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    /*
    https://www.codegrepper.com/code-examples/javascript/keycode+32
    A-Z = 65 to 90
    a-z = 97 to 122
    0-9 = 48 to 57
    dash = 45
    underscore = 95
    backspace = 8
    spacebar = 32
     */
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57) || k == 45 || k == 95);
  }
}
